let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1BteR")).then(() => parcelRequire('h2PNv'));